<ion-button
  *ngIf="curDelivery"
  (click)="onToggleFavorite($event)"
  shape="round"
  class="list-button"
  [class.favorite]="curDelivery?.favourite">
  <i class="fas fa-heart icon"></i>
</ion-button>
